import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { triggerFeedAudit } from '../services/feed-audit-workflow.service';

/** Triggers a FEED_AUDIT run; invalidates the landing list so the new run appears. */
export function useTriggerFeedAudit() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: triggerFeedAudit,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.catalogOperations.all });
    },
  });
}
